import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as S from './styles';
import { Table } from '~/components';
import { theme } from '~/styles/theme';
import { tableStructure } from './utils/tableStructure';

export default function ArbitrationMatches({
  matches,
  totalMatches,
  className,
}) {
  const { t } = useTranslation();
  const columns = React.useMemo(() => tableStructure(totalMatches), [
    totalMatches,
  ]);
  const tableStyles = {
    secondaryColor: theme.light2Opacity,
    textColor: theme.dark,
    fullWidth: true,
  };

  return (
    <S.Container className={className}>
      <S.TableContent>
        <Table
          fullWidth
          columns={columns}
          data={matches.map(match => {
            return {
              ...match,
              season: `${match.seasonYearStart}/${match.seasonYearEnd}`,
              yellowCards: `${match.yellowCards.homeStat} / ${match.yellowCards.awayStat}`,
              doubleYellowCards: `${match.doubleYellowCards.homeStat} / ${match.doubleYellowCards.awayStat}`,
              redCards: `${match.redCards.homeStat} / ${match.redCards.awayStat}`,
              faultsIndicated: `${match.faultsIndicated.homeStat} / ${match.faultsIndicated.awayStat}`,
              penaltiesIndicated: `${match.penaltiesIndicated.homeStat} / ${match.penaltiesIndicated.awayStat}`,
            };
          })}
          styleOptions={tableStyles}
          hasFooter
          responsiveHeader
        />
        <S.LegendContainer>
          <S.LegendItem>
            <S.LegendTitle>(L/V)</S.LegendTitle>:
            <S.LegendDescription>{t(`localAndVisitant`)}</S.LegendDescription>
          </S.LegendItem>
        </S.LegendContainer>
      </S.TableContent>
    </S.Container>
  );
}

ArbitrationMatches.propTypes = {
  className: PropTypes.string,
  matches: PropTypes.array,
  totalMatches: PropTypes.object,
};

ArbitrationMatches.defaultProps = {
  className: null,
  matches: null,
  totalMatches: {},
};
